<template><div><h1>date format</h1>
<p>相对<code>moment</code>来说<code>十分轻量</code>的实现。</p>
<h2>使用</h2>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { dateFormat } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

dateFormat(<span class="hljs-keyword">new</span> <span class="hljs-built_in">Date</span>(), <span class="hljs-string">'YYYY-MM-DD HH:mm:ss'</span>)
</code></pre>
<h2>作为 filter 使用</h2>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { dateFormat } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">filters</span>: {
    dateFormat
  }
}

</code></pre>
</div></template><script>
export default {
  head: {"title":"vue date 日期格式化 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// date-306.vue?384e43c8